"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.FormButtonBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _PopOverPrompt = require("../../Components/PopOverPrompt/PopOverPrompt");
var _FormButton = require("../FormButton/FormButton");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/prop-types */

const FormButtonBar = ({
  hideCancel,
  onSave,
  onCancel,
  saveText,
  cancelText,
  dirty,
  isValid,
  isSubmitting,
  saveButtonProgress,
  saveIcon,
  popOverPrompt
}) => {
  const {
    showPopOverPrompt,
    popOverPromptText,
    storage
  } = popOverPrompt;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "ccl-e-form-button-bar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl-e-form-button-bar__save",
      children: [showPopOverPrompt && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PopOverPrompt.PopOverPrompt, {
        arrowPosition: "bottom-center",
        htmlText: popOverPromptText,
        storage: storage
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormButton.FormButton, {
        progress: saveButtonProgress,
        "data-nw-action": "save",
        onClick: onSave,
        text: saveText,
        type: "save",
        icon: saveIcon
        // disabled if dirty is false or form is invalid or is submitting
        ,
        disabled: !dirty || !isValid || isSubmitting
      })]
    }), hideCancel != true && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl-e-form-button-bar__cancel",
      children: [isSubmitting, /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormButton.FormButton, {
        "data-nw-action": "cancel",
        text: cancelText,
        type: "cancel",
        onClick: onCancel,
        disabled: isSubmitting
      })]
    })]
  });
};
exports.FormButtonBar = FormButtonBar;
FormButtonBar.defaultProps = {
  onSave: () => {},
  onCancel: () => {},
  saveText: '',
  cancelText: '',
  popOverPrompt: {}
};